<script setup>
    import { defineProps } from "vue";

    const props = defineProps({
        iconWidth: String,
        iconHeight: String,
    });
</script>


<template>
    <svg 
        fill="currentColor" 
        :width="iconWidth"
        :height="iconHeight"
        viewBox="0 -2 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path 
            d="M5.002 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2h-14c-1.103 0-2 .897-2 2v6.001H10V7l6 5-6 5v-3.999H3.002V19c0 1.103.897 2 2 2z"
        />
    </svg>
</template>